<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import InputText from 'primevue/inputtext';
const { $toastService } = useNuxtApp();
const activeToastUrl = ref<string>();
const emits = defineEmits<{ (e: 'closeDevTools'): void }>();
</script>

<template>
  <div class="grid grid-cols-1 gap-2">
    <div class="text-base-priority text-xs">
      In order to force toast to appear you need to activate and navigate:
    </div>
    <div class="flex gap-2">
      <InputText
        v-model="activeToastUrl"
        title="Toast Url"
        placeholder="/toast-messages/jackpotcity/jza/jza_beta_toast"
        class="w-full max-w-[70%]"
      />
      <Button
        :disabled="!activeToastUrl"
        @click="[
          emits('closeDevTools'),
          $toastService.generateToast(activeToastUrl),
        ]"
      >
        Activate
      </Button>
    </div>
    <div class="text-base-priority text-xs">
      Example path: /toast-messages/jackpotcity/jza/jza_beta_toast
    </div>
    <div class="flex">
      <Button
        class="flex-center w-full"
        @click="$toastService.clearViewedToasts"
      >
        Reset Viewed
      </Button>
    </div>
  </div>
</template>
